import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import useSearchParams from '../../../hooks/useSearchParams'
import useProcedureCitizen from '../../../hooks/useProcedureCitizen'
import { isLoading } from '../../../hooks/useQuery'
import CitizenHeader from '../question_fields/CitizenHeader'
import Container from '../../atoms/Container'
import ProcedureGeneralInfo from './ProcedureGeneralInfo'
import TaskHistory from '../procedures/TaskHistory'
import DetailSelectTaskExecute from '../procedures/DetailSelectTaskExecute'
import ProcedureTaskExecutionsForm from '../procedure_managements/ProcedureTaskExecutionsForm'
import useTaskExecutionCitizen from '../../../hooks/useTaskExecutionCitizen'

const TrackingProcedure = ({ code }) => {
  const searchParams = useSearchParams()
  const token = searchParams.get('token')
  const { procedure, status, invalidateProcedureQueries } = useProcedureCitizen(code, token)
  const { updateTaskExecution } = useTaskExecutionCitizen(code)
  const [selectedTaskId, setSelectedTaskId] = useState('')

  useEffect(() => {
    if (isLoading(status) || procedure?.task_executions?.length <= 1) return null

    const lastTaskExecution = procedure.task_executions[procedure.task_executions.length - 1]
    const notifiableAndNotVisualizedYet = lastTaskExecution.notifiable && !lastTaskExecution.already_visualized
    if (notifiableAndNotVisualizedYet) {
      updateTaskExecution({ id: lastTaskExecution.id, token })
    }
  }, [procedure])

  if (isLoading(status)) return null
  return (
    <>
      <CitizenHeader name="Seguimiento de tu solicitud" institution={procedure.institution} />
      <Container className="py-12">
        <div className="flex flex-col md:flex-row gap-6 mb-6">
          <div className="w-full md:w-5/12 lg:w-3/12">
            <ProcedureGeneralInfo procedure={procedure} />
          </div>
          <div className="w-full md:w-7/12 lg:w-9/12">
            <TaskHistory
              title="Historial de avances"
              taskExecutions={procedure.task_executions}
              taskRuleExecutions={procedure.task_rule_executions}
            />
            {procedure.enabled_tasks.length > 0 && (
              <DetailSelectTaskExecute
                enabledTasks={procedure.enabled_tasks}
                value={selectedTaskId}
                onSelect={setSelectedTaskId}
              />
            )}
          </div>
        </div>
        {selectedTaskId !== '' && (
          <ProcedureTaskExecutionsForm
            procedureCode={code}
            token={token}
            taskId={selectedTaskId}
            onAfterSave={() => {
              setSelectedTaskId('')
              invalidateProcedureQueries()
            }}
          />
        )}
      </Container>
    </>
  )
}

export default TrackingProcedure

TrackingProcedure.propTypes = {
  code: PropTypes.string
}
